module.exports = __webpack_public_path__ + "img/twokinds.8efe3b13.png";